<script setup lang="ts">
import { DeleteConfirmationModal } from '@/components/common/DeleteConfirmationModal'
import { useClaims } from '@/composables/asicw/claims'
import { ClaimStatus, type IClaimDashboard } from '@/types/asicw/claims'
import { ref } from 'vue'

interface ClaimCostsDialogProps {
  claim?: IClaimDashboard
}

const props = defineProps<ClaimCostsDialogProps>()

const dialogVisible = defineModel<boolean>()
const formRef = ref()

const { updateClaimCostsMutation } = useClaims()
const { mutateAsync: updateClaimCosts, isPending: isUpdatePending } = updateClaimCostsMutation

const handleOpen = () => {
  formRef.value?.init()
}
const handleClosed = () => {
  formRef.value?.resetFields()
}
const handleSave = () => {
  formRef.value?.submit()
}

const handleSubmit = async (form: any) => {
  try {
    if (props.claim && props.claim.status === ClaimStatus.Invoiced) {
      DeleteConfirmationModal(
        'Warning',
        'Updating the costs of an invoiced claim will also refresh any invoices associated with it. Are you sure you want to proceed?',
        form,
        updateClaimCosts,
        () => {
          dialogVisible.value = false
        },
        'Continue'
      )
    } else {
      await updateClaimCosts(form)
      dialogVisible.value = false
    }
  } catch {
    // Error is handled by mutation error handler
  }
}
</script>

<template>
  <el-dialog
    v-model="dialogVisible"
    title="Edit claim costs"
    width="800px"
    align-center
    :show-close="false"
    @open="handleOpen"
    @closed="handleClosed"
  >
    <ClaimCostsForm v-if="props.claim" ref="formRef" :claim="props.claim" @submit="handleSubmit" />
    <template #footer>
      <el-button @click="dialogVisible = false">Cancel</el-button>
      <el-button type="primary" :loading="isUpdatePending" @click="handleSave">Save</el-button>
    </template>
  </el-dialog>
</template>
